<template>
  <PaginationWrapper
    :page="page"
    :pageSize="50"
    :totalCount="totalCount"
    @onPageChange="handlePageChange"
    export
    @exportTable="exportList"
  >
    <LogsOCPISearchOptions @onSearch="handleSearch" slot="search-options" />
    <div slot="table">
      <LogsTableOCPI />
    </div>
  </PaginationWrapper>
</template>
<script>
import PaginationWrapper from '@/components/sections/common/PaginationWrapper.vue';
import LogsOCPISearchOptions from '@/components/sections/logs/LogsOCPISearchOptions.vue';
import LogsTableOCPI from '@/components/sections/logs/LogsTableOCPI.vue';

export default {
  name: 'OCPILogsList',
  components: {
    PaginationWrapper,
    LogsOCPISearchOptions,
    LogsTableOCPI,
  },
  data() {
    return {
      query: {},
      activeTab: 0,
      page: 1,
      totalCount: 0,
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.$store.dispatch('storeLoading', true);
      if (Object.keys(this.query).length === 0) {
        this.query.startDate = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000);
        this.query.endDate = new Date();
      }
      this.totalCount = await this.$store.dispatch('storeLogsOCPI', {
        query: {
          ...this.query,
          component: 'OCPI',
        },
        page: this.page,
      });
      this.$store.dispatch('storeLoading', false);
    },
    async handleSearch(query) {
      this.page = 1;
      this.query = query;
      await this.fetchData();
    },
    async handlePageChange(page) {
      this.page = page;
      await this.fetchData();
    },
    async exportList() {
      await this.$store.dispatch('storeLoading', true);

      try {
        const file = await this.$store.dispatch('exportList', {
          query: {
            ...this.query,
            component: 'OCPI',
          },
          type: 'ocpiLogs',
        });

        if (file.data === '') {
          this.$message.error(
            this.$t('components.alerts.exportFileError', { type: 'ocpiLogs' }),
          );
        } else {
          const fileURL = window.URL.createObjectURL(new Blob([file.data]));
          const fileLink = document.createElement('a');

          fileLink.href = fileURL;
          fileLink.setAttribute(
            'download',
            `ocpiLogs-${new Date()
              .toISOString()
              .slice(0, 10)
              .replaceAll('-', '')}.csv`,
          );
          document.body.appendChild(fileLink);

          fileLink.click();
          this.$message.success(
            this.$t('components.alerts.exportSuccess', { type: 'ocpiLogs' }),
          );
        }
      } catch (e) {
        this.$message.error(
          this.$t('components.alerts.exportError', { type: 'ocpiLogs' }),
        );
        console.log(e);
      }

      await this.$store.dispatch('storeLoading', false);
    },
  },
};
</script>
